import { Page } from "src/store/tableData/types";
import { Dictionary } from "../globalTypes";

// eslint-disable-next-line import/prefer-default-export
export function getFirstMissingIndex(
  pages: Dictionary<number, Page>,
  startFrom = 0
) {
  // eslint-disable-next-line no-constant-condition
  for (let i = startFrom; true; i += 1) {
    if (!pages[i]) return i;
  }
}

export const isEmpty = <T extends Record<string, unknown>>(obj: T) =>
  Object.keys(obj).length === 0;
